import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '$store';
import { onCloseConfirmCancelModal, onConfirmCancelModal } from '~modules/media-library/controller/thunks/contribute';

export function ContributeConfirmCancelModal() {
  const data = useSelector((store: RootState) => store.contribute);

  const dispatch = useDispatch();

  const { confirmCancelModalIsOpen, isProcessInProgress, uploadInProgress } = data;

  const onConfirm = useCallback(() => {
    dispatch(onConfirmCancelModal());
  }, [dispatch]);
  const onClose = useCallback(() => {
    dispatch(onCloseConfirmCancelModal());
  }, [dispatch]);

  return (
    <Transition show={confirmCancelModalIsOpen} as={Fragment}>
      <Dialog onClose={onClose} as="div" className="relative z-40">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-50"
          leave="ease-in duration-200"
          leaveFrom="opacity-50"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black opacity-50" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto flex items-start justify-center ">
          <div className="flex items-start justify-center min-h-screen p-4 text-center mt-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="ml--detail-modal--panel bg-white overflow-y-auto rounded-md shadow-xl w-full max-w-lg flex flex-col relative">
                {isProcessInProgress && !uploadInProgress && (
                  <>
                    <header className="ml--detail-modal--panel-header flex justify-center">
                      <h2 className="ml--detail-modal--title font-semibold text-base text-center p-2">
                        A process is currently in progress. <br />
                        Are you sure you want to close?
                      </h2>
                    </header>
                    <div className="raise-request-assets-form container py-1 px-3">
                      <div className="flex my-4 justify-center">
                        <button
                          className="button c-button c-button--dark u-padding-horizontal-lg mx-2"
                          onClick={onConfirm}
                        >
                          Confirm
                        </button>
                        <button
                          className="button c-button c-button--light u-padding-horizontal-lg mx-2"
                          onClick={onClose}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
